import { render } from "./FutureReceivable.vue?vue&type=template&id=61a4a414"
import script from "./FutureReceivable.vue?vue&type=script&lang=js"
export * from "./FutureReceivable.vue?vue&type=script&lang=js"

import "./FutureReceivable.vue?vue&type=style&index=0&id=61a4a414&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__